import { Navigate, Outlet, useLocation } from "react-router-dom";

function RequireWebfleetAuth() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    if (params.get("ex")) {
        // ToDo: Check. Old Auth was here
        return <Navigate to={location.pathname} replace />;
    }

    return <Outlet />;
}

export default RequireWebfleetAuth;
